import React from "react";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const DivSpinner = ({height = 387, fixHeight = 0}) => {
    return(
        <div style={{ height: fixHeight > 0 ? `${fixHeight}px` : `${window.innerHeight - height}px` }}>
            <Box 
                sx={{
                    display: 'flex',
                    justifyContent: 'center', // Center horizontally
                    alignItems: 'center',    // Center vertically
                    height: '100%',         // Ensure the container takes full height
                }}
            >
                <CircularProgress color="inherit"/>
            </Box>
        </div>
    );
}

export default DivSpinner;